import React from "react";

const prizesData = [
  {
    testimonial:
      "Experiência gastronômica no Tatá Cozinha de Origem, São Mateus",
    description:
      "Viva uma experiência gastronômica única no Tatá Cozinha de Origem, em São Mateus. Descubra sabores autênticos, preparados com ingredientes locais e técnicas inovadoras que valorizam a culinária regional. Uma imersão completa para os amantes da boa gastronomia.",
  },
  {
    testimonial: "Viagem para Expo Revestir 2027",
    description:
      "Participe da Expo Revestir 2027, a maior feira de revestimentos e acabamentos da América Latina. Explore as últimas tendências em design, descubra lançamentos inovadores e amplie seu networking com profissionais e empresas do setor. Uma experiência essencial para quem busca atualização e inspiração no mercado.",
  },
  {
    testimonial: "Viagem para Santiago, Chile",
    description:
      "Explore Santiago, uma cidade vibrante cercada pela Cordilheira dos Andes. Descubra bairros charmosos e mercados locais, enquanto aproveita a cultura, gastronomia e paisagens únicas que tornam a capital chilena inesquecível.",
  },
  {
    testimonial: "Viagem para Istambul, Turquia",
    description:
      "Descubra Istambul, onde o Oriente encontra o Ocidente. Encante-se com mesquitas históricas, mercados coloridos e palácios impressionantes, mergulhando na cultura e gastronomia turca para uma viagem cheia de experiências inesquecíveis.",
  },
];

export default function PrizesSection() {
  return (
    <section className="max-w-5xl mx-auto w-full px-10" id="prizes">
      <div className="flex items-center justify-center flex-col gap-y-2 py-5">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
          Prêmios
        </h2>
        <p className="text-lg font-medium text-white">
          Os prêmios dessa edição foram pensados para enriquecer culturamente
          nossos grandes parceiros
        </p>
      </div>

      <div className="flex items-center justify-center flex-col lg:grid lg:grid-cols-2 gap-5 w-full">
        {prizesData.map((testimonial, index) => (
          <div
            key={index}
            className={`h-full border p-7 rounded-xl bg-emerald-100 drop-shadow-md border-neutral-200/50  flex flex-col gap-y-10 justify-between`}
          >
            <div className="flex flex-col gap-y-3.5">
              <p className="font-bold text-xl text-emerald-900">
                {testimonial.testimonial}
              </p>
              <p className="font-medium text-emerald-950">
                {testimonial.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
